import { showToast } from "../../utils/toast";
import { sendJson } from "./request";
import { refreshList } from "./refresh";
import { resortCampaigns } from "./campaigns_view";

const STARS_URL = "/customer_success/campaign_stars";

function setStarred(button: HTMLElement, on: boolean): void {
  button.classList.toggle("on", on);
  button.setAttribute("aria-pressed", String(on));
  button.setAttribute("aria-label", `${on ? "Unstar" : "Star"} campaign`);
  button.title = on ? "Starred — click to unstar" : "Star to pin this campaign to the top";
  button.closest("tr")?.classList.toggle("starred", on);

  const count = document.querySelector<HTMLElement>("[data-cv-starred-count]");
  if (count) count.textContent = String(Math.max(0, Number(count.textContent) + (on ? 1 : -1)));
}

async function toggleStar(button: HTMLElement): Promise<void> {
  const botId = button.dataset.cvStar;
  if (!botId || button.dataset.busy) return;

  const on = !button.classList.contains("on");
  button.dataset.busy = "1";
  setStarred(button, on);
  resortCampaigns();
  button.focus({ preventScroll: true });

  const result = on
    ? await sendJson(STARS_URL, "POST", JSON.stringify({ bot_id: botId }))
    : await sendJson(`${STARS_URL}/${encodeURIComponent(botId)}`, "DELETE", "{}");
  delete button.dataset.busy;

  if (!result.ok) {
    setStarred(button, !on);
    resortCampaigns();
    showToast("Couldn't save the star, try again", "error");
    return;
  }
  showToast(on ? "Starred — pinned to the top" : "Removed from starred");
  if (!on && document.querySelector<HTMLInputElement>("#cv-starred input")?.checked) refreshList();
}

export function bindCsCampaignStars(): void {
  document.addEventListener("click", (e) => {
    const button = (e.target as HTMLElement).closest<HTMLElement>("[data-cv-star]");
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    toggleStar(button);
  });
}
